import { computed, Injectable, signal } from '@angular/core';
import { CheckoutReducer } from '@app/pages/checkout-app/checkout-store/reducers';
import { Store } from '@ngrx/store';
import * as fromCheckoutReducer from '@pages/checkout-app/checkout-store/reducers/checkout.reducer';

@Injectable()
export class CheckoutExampleService {
  readonly orderSubtotal = signal<number>(60);
  readonly orderShipping = signal<number>(5);
  readonly orderTotal = computed(() => this.orderSubtotal() + this.orderShipping());
  readonly showOrderSummaryPreview = signal<boolean>(false);
  readonly liveExampleTemplate$ = this.store.select(CheckoutReducer.selectLiveExampleTemplateView);

  constructor(private store: Store<fromCheckoutReducer.State>) {}
}
